export default {
    "name": "DashboardReportChartMembership",
    "kind": "HoudiniQuery",
    "hash": "af58046eba21ca8e4d725d868aa0eb7c193d7a0d8549f2e6d8f721eb0cbe8c75",

    "raw": `query DashboardReportChartMembership($reportId: Int!) {
  dashboardChartMembership(reportId: $reportId) {
    chartId: id
    rank
    title
    supertype
    inReport
    chartType: type
    showChart: display
    id
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "dashboardChartMembership": {
                "type": "DashboardChart",
                "keyRaw": "dashboardChartMembership(reportId: $reportId)",

                "selection": {
                    "fields": {
                        "chartId": {
                            "type": "Int",
                            "keyRaw": "chartId",
                            "visible": true
                        },

                        "rank": {
                            "type": "Int",
                            "keyRaw": "rank",
                            "nullable": true,
                            "visible": true
                        },

                        "title": {
                            "type": "String",
                            "keyRaw": "title",
                            "visible": true
                        },

                        "supertype": {
                            "type": "DashboardChartSupertype",
                            "keyRaw": "supertype",
                            "visible": true
                        },

                        "inReport": {
                            "type": "Boolean",
                            "keyRaw": "inReport",
                            "nullable": true,
                            "visible": true
                        },

                        "chartType": {
                            "type": "String",
                            "keyRaw": "chartType",
                            "nullable": true,
                            "visible": true
                        },

                        "showChart": {
                            "type": "Boolean",
                            "keyRaw": "showChart",
                            "visible": true
                        },

                        "id": {
                            "type": "Int",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "reportId": "Int"
        },

        "types": {},
        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=f84255456d1be68c9f8833daf2b12068015c99972c7d359a65a74edf3b830546";